import { createContext, useContext } from 'react';
const noopTrack = () => {};
export const AccessCheckTrackingContext = /*#__PURE__*/createContext(noopTrack);
export function useAccessCheckTracking() {
  return useContext(AccessCheckTrackingContext);
}